import GridPostsHome from "./grid-posts.component";

export default GridPostsHome;
